// ISV服务商管理列表
import api from '../api';
import { get, post, put } from 'store/request';
import { Category } from 'pages/manage/application/constants';

// 应用管理列表
export const getIsvAppList = async () => {
  const appList = await get(api.getIsvAppList);
  return appList;
};

// 应用管理详情
export const getIsvAppDetail = async (id: string) => {
  const result = await get(`${api.getIsvAppDetail}/${id}`);
  let data = {
    client_id: {
      text: result?.client_id,
      field_name: 'FApplication_one',
      field_zh_name: '应用ID',
      field_group: 'application',
    },
    app_name: {
      text: result?.app_name,
      field_name: 'FApplication_two',
      field_zh_name: '应用名称',
      field_group: 'application',
    },
    app_icon: {
      value: [{ url: result?.app_icon, name: '应用图标' }],
      field_name: 'FImage_app_icons',
      field_zh_name: '应用图标',
      field_group: 'application',
    },
    category: {
      value: result?.category,
      field_zh_name: '应用类型',
      field_name: 'Fcategory',
      field_group: 'application',
    },
    app_token: {
      field_zh_name: 'app_token',
      field_name: 'FApplication_one',
      text: result?.app_token,
      field_group: '',
    },
    version: {
      text: result?.version,
      field_zh_name: '版本号',
      field_name: 'FApplication_one',
      field_group: 'application',
    },
    app_desc: {
      text: result?.app_desc,
      field_zh_name: '应用描述',
      field_name: 'FApplication_one',
      field_group: 'application',
    },
    website_url: {
      value: result?.website_url,
      field_name: 'FApplication_link_app',
      field_zh_name: '应用网址',
      field_group: 'application',
    },
    provider: {
      text: result?.provider,
      field_name: 'FApplication_one',
      field_zh_name: '应用提供方',
      field_group: 'application',
      highlight: false,
    },
    app_image_list: {
      value: result?.app_image_list,
      field_name: 'FImage_screen_shot',
      field_zh_name: '应用截图',
      field_group: 'application',
      highlight: false,
    },
    industry_id: {
      value: result?.industry_id,
      field_name: 'FIndustry_id',
      field_zh_name: '所属行业',
      field_group: 'application',
    },
    extra: {
      value: result?.extra,
      field_name: 'extra',
    },
    redirect_uri: {
      value: result?.redirect_uri,
      field_name: 'FApplication_link',
      field_zh_name: '回调URL',
      field_group: 'application',
    },
  };

  if ([Category.contentService,  Category.dataService, Category.daiyunying].includes(result?.category)) {
    data = {
      client_id: {
        text: result?.client_id,
        field_name: 'FApplication_one',
        field_zh_name: '应用ID',
        field_group: 'application',
      },
      app_name: {
        text: result?.app_name,
        field_name: 'FApplication_two',
        field_zh_name: '应用名称',
        field_group: 'application',
      },
      app_icon: {
        value: [{ url: result?.app_icon, name: '应用图标' }],
        field_name: 'FImage_app_icons',
        field_zh_name: '应用图标',
        field_group: 'application',
      },
      category: {
        value: result?.category,
        field_zh_name: '应用类型',
        field_name: 'Fcategory',
        field_group: 'application',
      },
      app_token: {
        field_zh_name: 'app_token',
        field_name: 'FApplication_one',
        text: result?.app_token,
        field_group: '',
      },
      version: {
        text: result?.version,
        field_zh_name: '版本号',
        field_name: 'FApplication_one',
        field_group: 'application',
      },
      app_desc: {
        text: result?.app_desc,
        field_zh_name: '应用描述',
        field_name: 'FApplication_one',
        field_group: 'application',
      },
      provider: {
        text: result?.provider,
        field_name: 'FApplication_one',
        field_zh_name: '应用提供方',
        field_group: 'application',
        highlight: false,
      },
      app_image_list: {
        value: result?.app_image_list,
        field_name: 'FImage_screen_shot',
        field_zh_name: '应用截图',
        field_group: 'application',
        highlight: false,
      },
      industry_id: {
        value: result?.industry_id,
        field_name: 'FIndustry_id',
        field_zh_name: '所属行业',
        field_group: 'application',
      },
      extra: {
        value: result?.extra,
        field_name: 'extra',
      },
    };
  }

  // 私域运营展示app_token
  if (result?.category === Category.privateDomain) {
    data.app_token = {
      ...data.app_token,
      field_group: 'application',
    };
  }
  return data;
};

// 应用编辑
export const applyEdit = (params: object) => put(api.applyEdit, params);

// 应用添加
export const applyAdd = (params: object) => post(api.applyAdd, params);
